import React, { Component } from 'react'
import DeletePeople from '../../Services/Mutations/DeletePeople'
import { BrowserRouter, Route, Switch, Link } from 'react-router-dom'
import { Button, Modal, Table } from 'react-bootstrap'
import { Auth } from 'aws-amplify'
import 'react-date-range/dist/styles.css' // main style file
import 'react-date-range/dist/theme/default.css' // theme css file
import { DateRangePicker } from 'react-date-range'
import ListPeopleService from '../../Services/Queries/ListPeople'
import _ from 'lodash'
import { ToastContainer, toast } from 'react-toastify'
import AwsConfig from '../../Config/AwsConfig'
import GetUserPermissions from '../../Services/Queries/GetUserPermissions'
import { DefinedPermissions } from '../Constants/Permissions'
import 'react-toastify/dist/ReactToastify.css'
import GetListOfCompanies from '../../Services/Queries/GetListOfCompanies'

import UnRegisterCompany from '../../Services/Mutations/UnregisterCompany'
import CompanyDetails from '../Jobs/CompanyDetails'
import RegisterCompany from '../../Services/Mutations/RegisterCompany'
import { updateRegisteredCompanyDetails } from '../../Graphql/mutations'
import UpdateRegisteredCompanyDetails from '../../Services/Mutations/UpdateRegisteredCompany'
import MandatoryValidations from '../content/SubComponents/MandatoryValidations'

class ListCompanies extends React.Component {
	toastStyle = {
		position: 'top-right',
		autoClose: 5000,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		progress: undefined,
	}
	constructor(props) {
		super(props)

		this.state = {
			mandatoryFieldsData: [],
			limit: 10,
			nextToken: null,
			headings: ['N.o', 'Actions', 'CompanyLogo', 'CompanyName', 'About Company', 'Company ContactDetails ', 'Company Address', 'CompanyID'],
			deleteModalVisible: false,
			editCompaniesModalVisible: false,
			registerCompanyModalVisible: false,
			companyList: '',
			loggedInUserPermissions: [],
			selectedCompanyId: '',
			selectedContentType: 'company',
			searchQuery: '',
			company: '',
			editCompany: '',
			contactName: '',
			jobApplicationLink: '',
			companyName: '',
			companyBio: '',
			companyAddress: '',
			companyEmail: '',
			phoneNumber: '',
			GST: '',
			DisabledRegisterCompany: true,
			DisabledUpdateRegisterCompany: true,
			enableCreateCompany: false,

			selectionRange: {
				startDate: new Date(),
				endDate: new Date(),
				key: 'selection',

			},
			companyDetails: {
				companyName: '',
				companyBio: '',
				companyAddress: '',
				companyEmail: '',
				phoneNumber: '',
				GST: '',
				companyWebsite: '',
				contactName: '',
				jobApplicationLink: '',

			},
			editCompanyDetails: {
				PK: '',
				SK: '',
				companyName: '',
				companyBio: '',
				companyAddress: '',
				companyEmail: '',
				phoneNumber: '',
				GST: '',
			},
		}
		this.contentImage = ''
		this.contentImages = []
		this.contentStatus = ''
		this.isPreviouslyCampaign = false
		this.InAppMessageChild = React.createRef()
		this.isPreviouslyStickyPost = false
		this.missingMandatoryFields = true
		this.missingSubContentMandatoryFields = true
		this.job = {}

		this.loadMore = this.loadMore.bind(this)
	}
	// jobData = (key, value) => {
	// 	if (key !== 'companyDetails') {
	// 		this.job[key] = value
	// 	} else {
	// 		this.job['companyName'] = value.companyName
	// 		this.job['companyBio'] = value.companyBio
	// 		this.job['companyRegisteredAddress'] = value.companyAddress
	// 		this.job['contactMobileNumber'] = value.phoneNumber
	// 		this.job['contactEmail'] = value.companyEmail
	// 		this.job['companyWebsite'] = value.companyWebsite
	// 		// this.job['jobImages'] = value.companyLogo
	// 		this.job['displayMobileNumberInJobPost'] = value.displayMobileNumberInJobPost

	// 	}
	// 	if (key.includes('jobTitle') && value) {
	// 		this.setState({ pnTitle: value.substring(0, 45) })
	// 	}
	// 	if (!this.state.editContent && key.includes('jobDescription') && value) {
	// 		this.setState({ pnDescription: value, bigTextTitle: value })
	// 	}
	// 	if (key.includes('jobImages') && value && value[0]) {
	// 		this.contentImage = value[0].image
	// 		this.contentImages = value[0].image
	// 	}
	// }
	updateInParent = (key, value, type, subType) => {
		const { enableCreateContent } = this.state

		this.jobData(key, value)

		// const createContentValidation = this.checkCreateContentValidations()
		// if (enableCreateContent != createContentValidation) {
		// 	this.setState({
		// 		enableCreateContent: createContentValidation,
		// 		updateErrorValidations: !this.state.updateErrorValidations,
		// 	})
		// } else {
		// 	this.setState({ updateErrorValidations: !this.state.updateErrorValidations })
		// }
	}
	getContentUri = (items) => {

		// console.log(items, 'itemsssssssssssssss2222')
		const cdnurl = AwsConfig.cdn_url
		// console.log(cdnurl, 'this is cdnurlllll')
		let uri = items.companyLogo
		// console.log(uri, 'this is uriiiiiiiiiii')
		if (uri && !uri.includes(cdnurl)) {
			uri = cdnurl + items.companyLogo
			// console.log(uri, 'this is inside if condition')
		}
		return uri
	}
	loadMore = async () => {
		await this.getNextCompaniesLists()
	}
	getCompaniesLists = async (searchQuery) => {
		const input = {
			limit: this.state.limit,

		}
		if (searchQuery) {
			input.search = searchQuery
		}
		// console.log(input, 'inputttt')
		const data = await GetListOfCompanies(input)
		// console.log(data, 'dataaaaa')

		const permissionInput = {
			mobileNumber: Auth.user.attributes.phone_number,
		}
		const userPermissions = await GetUserPermissions(permissionInput)
		let permissions = []
		let permissionsArr = []
		if (userPermissions && userPermissions.userRolesAndPermissions) {
			userPermissions.userRolesAndPermissions.map((item) => {
				permissions.push(...item.permissions)
			})
			permissions.map((permission) => {
				permissionsArr.push(permission.name)
			})
		}
		// console.log(permissionsArr, 'permissionsArr')

		this.setState({
			companyList: data.items,
			nextToken: data.nextToken,
			loggedInUserPermissions: permissionsArr,
		})
	}


	getNextCompaniesLists = async () => {
		// console.log('inside getNextCompaniesLists')
		const input = {
			limit: this.state.limit,
			nextToken: this.state.nextToken,
		}
		console.log(input, 'input====')
		const data = await GetListOfCompanies(input)
		console.log(data, 'data is')
		this.setState({
			companyList: [...this.state.companyList, ...data.items],
			nextToken: data.nextToken ? data.nextToken : null,
		})
	}
	onChangeSearch = (searchQuery) => {
		this.setState({ searchQuery: searchQuery })

	}
	search = () => {
		this.getCompanyDetails(this.state.searchQuery)
	}
	clearSearch = () => {
		this.setState({
			searchQuery: '',
			from: 0,
			searched: false,
			filtered: false,
			selectionRange: {
				startDate: new Date(),
				endDate: new Date(),
				key: 'selection',
			},
			selectedFilterType: '',
		})
		this.getCompanyDetails()
	}
	getCompanyDetails = async (search) => {
		const input = {
			limit: this.state.limit,

			search: search
		}
		const data = await GetListOfCompanies(input)
		// console.log(data.items, 'here is the dataaaaaaaaaaa')
		this.setState({
			nextToken: data.nextToken,

			companyList: data.items
		})
		// console.log(peopleList, 'here is the people listttttttttttt')
		// console.log(data, 'datadatadatadatadata')
	}
	async componentDidMount() {
		this.renderContentMandatoryValidations(this.state.companyDetails)
		// if (this.state.editCompany) {
		// 	this.checkCompanyValidations(this.state.editCompany)
		// }
		this.getCompanyDetails()
		// this.setState({ companyDetails : })
		this.setState((editCompany) => ({
			companyDetails: editCompany
		}))


	}
	openDeleteModal = (item) => {
		this.setState({ selectedCompanyId: item, deleteModalVisible: true })
	}
	closeDeleteModal = (item) => {
		this.setState({ selectedCompanyId: '', deleteModalVisible: false })
	}

	handleDelete = async () => {
		// console.log("inside handle delete ")
		const item = this.state.selectedCompanyId
		// console.log(item, 'itemssssssss22222222222')
		this.setState({ deleteModalVisible: false })
		const input = {
			PK: item.PK,
			SK: item.SK
		}


		// console.log(input, 'input')
		const data = await UnRegisterCompany(input)
		// console.log(this.state.companyList, 'here is the company lists')
		// const remainingData = companyList.filter((i) => i.PK !== data.PK)
		// console.log(remainingData, 'here is the dataaaaaaaaaaa22222')
		// const deletedData = data.filter((i) => i.PK !== item.PK)
		// console.log(deletedData, 'here is the remaining list of data')
		// this.setState({
		// 	selectedCompanyId: data,
		// })


		if (data.statusCode == 'A353') {
			toast.success('Company Deleted Successfully', this.toastStyle)

			const refreshedCompanyList = this.state.companyList
			// console.log(refreshedCompanyList, 'here is the list');
			const list = refreshedCompanyList.filter((data) => data.SK !== item.SK)
			// console.log(list, 'here is the list2222');
			this.setState({ companyList: list })
		} else {
			toast.error('Failed To Delete company', this.toastStyle)
		}
	}
	handleEdit = async () => {
		// console.log('hellooo inside edit')

		const item2 = this.state.companyDetails

		const editItem = this.state.editCompany
		// console.log(this.state.editCompany, 'editCompany===========')
		// console.log(item2, 'here is the companydetails');
		this.setState({ editCompaniesModalVisible: false })
		const input = {
			PK: editItem.PK,
			SK: editItem.SK,
			companyName: item2.companyName,
			companyBio: item2.companyBio,
			companyAddress: item2.companyAddress,
			companyEmail: item2.companyEmail,
			phoneNumber: item2.phoneNumber,
			GST: item2.GST,
			companyLogo: item2.companyLogo,
			companyWebsite: item2.companyWebsite,
			contactName: item2.contactName,
			jobApplicationLink: item2.jobApplicationLink,
			displayMobileNumberInJobPost: item2.displayMobileNumberInJobPost

		}


		// this.setState(c)
		// this.setState({ companyDetails: input })
		console.log(input, 'here is the inputttt');
		// this.checkCompanyValidations(input)
		const updateData = await UpdateRegisteredCompanyDetails(input)
		console.log(updateData, 'here is the updated data')
		if (updateData.statusCode == 'A352') {
			toast.success('Company updated Successfully', this.toastStyle)
		} else {
			toast.error('Failed To Delete company', this.toastStyle)
		}
		this.getCompanyDetails()

	}
	openEditModal = (item) => {
		// console.log(item, 'this is the item')
		this.checkCompanyValidations(item)
		this.setState({ editCompany: item, editCompaniesModalVisible: true, companyDetails: item })

	}
	closeEditModal = (item) => {
		this.setState({ editCompany: '', editCompaniesModalVisible: false })
	}
	renderEditCompaniesModal = () => {
		const { editCompaniesModalVisible, mandatoryFieldsData } = this.state
		// console.log(this.state.editCompany, "==========renderEditCompaniesModal")
		return (
			<Modal show={editCompaniesModalVisible} onHide={() => this.closeEditModal()}>
				<Modal.Body>
					<CompanyDetails
						createMode={true}
						companyDetails={this.state.companyDetails}
						registerCompany={this.registerCompany}
						editCompany={this.state.editCompany}
					// mandatoryFieldsData={mandatoryFieldsData}
					/>

				</Modal.Body>
				<Modal.Footer>
					<Button onClick={() => this.closeEditModal()}>Cancel</Button>
					<Button
						disabled={this.state.DisabledUpdateRegisterCompany}
						onClick={() => this.handleEdit(this.state.editCompany)}>UpdateCompany</Button>

				</Modal.Footer>
			</Modal>
		)
	}

	handleRegisterCompany = async () => {

		// console.log("inside handle registercomapny ")
		const item = this.state.companyDetails
		// console.log(item, 'itemssssssss22222222222')
		this.setState({
			registerCompanyModalVisible: false
		})
		const input = {
			companyName: item.companyName,
			companyBio: item.companyBio,
			companyAddress: item.companyAddress,
			companyEmail: item.companyEmail,
			phoneNumber: item.phoneNumber,
			companyLogo: item.companyLogo,
			companyWebsite: item.companyWebsite,
			displayMobileNumberInJobPost: item.displayMobileNumberInJobPost,
			GST: item.GST,
			contactName: item.contactName,
			jobApplicationLink: item.jobApplicationLink
		}

		// this.checkCompanyValidations(input)
		console.log(input, 'here is the input data')
		const createData = await RegisterCompany(input)
		console.log(createData, 'here is the data from service')
		if (createData.statusCode == 'A351') {
			toast.success('Registered company successfully', this.toastStyle)
		} else {
			toast.error('Failed To Delete company', this.toastStyle)
		}
		this.getCompanyDetails()
	}
	renderDeleteConfirmationModal = () => {
		const { deleteModalVisible } = this.state
		return (
			<Modal show={deleteModalVisible} onHide={() => this.closeDeleteModal()}>
				<Modal.Body>
					<div className='row'>
						<text>Are you sure you want to delete this company?</text>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<Button onClick={() => this.closeDeleteModal()}>Cancel</Button>
					<Button onClick={() => this.handleDelete(this.state.PK, this.state.SK)}>Ok</Button>
				</Modal.Footer>
			</Modal>
		)
	}
	checkCompanyValidations = (companyDetails, allMandatoryValidations) => {
		console.log(companyDetails, 'handleRegisterDisable===========');
		const companyName = companyDetails?.['companyName'] != undefined && companyDetails?.['companyName'] != null && companyDetails?.['companyName'] != ''
		const companyBio = companyDetails?.['companyBio'] != undefined && companyDetails?.['companyBio'] != ''
		const contactValidation = (companyDetails?.[`companyEmail`] != undefined && companyDetails?.[`companyEmail`] != '') || (companyDetails?.[`companyWebsite`] != undefined && companyDetails?.[`companyWebsite`] != '')
			|| (companyDetails?.[`phoneNumber`] != undefined && companyDetails?.[`phoneNumber`] != '')

		const disableButton = companyDetails.companyName && companyDetails.companyBio && (companyDetails.companyEmail || companyDetails.phoneNumber || companyDetails.companyWebsite)
			? false : true
		const disableButton2 = companyDetails.companyName && companyDetails.companyName != '' && companyDetails.companyBio && companyDetails.companyBio != '' && (companyDetails.companyEmail && companyDetails.companyEmail != '' || companyDetails.phoneNumber && companyDetails.phoneNumber != '' ||
			companyDetails.companyWebsite && companyDetails.companyWebsite != '')
			? false : true
		console.log(disableButton2, 'companyy name')
		this.setState({ DisabledRegisterCompany: disableButton })
		this.setState({ DisabledUpdateRegisterCompany: disableButton2 })
		if (allMandatoryValidations) {
			return {

				[`Company Name`]: companyName,
				[`Company About`]: companyBio,
				[`Company: Contact Email/Mobile Number/Company Website`]: contactValidation,

			}
		}
		return companyName && companyBio && contactValidation
	}
	renderContentMandatoryValidations = (companyData) => {
		const allMandatoryValidations = true
		//const job=
		//const { selectedContentType } = this.state
		// console.log(this.job, 'this is the job')
		const data = this.checkCompanyValidations(companyData, allMandatoryValidations)
		// console.log(data,'inside renderContent Mandatory')
		return this.displayMandatoryValidations(data)
	}
	displayMandatoryValidations = (data) => {
		// console.log(data, 'inside validations')
		const allMandatoryValidations = true
		//const generalAndOtherOptionValidations = this.checkDisabled(allMandatoryValidations)
		//const totalContentMissingFieldsObj = { ...generalAndOtherOptionValidations, ...data }
		const totalContentMissingFieldsObj = { ...data }
		const totalContentMissingFields = Object.keys(totalContentMissingFieldsObj)?.filter(
			(key) => totalContentMissingFieldsObj[key] == false
		)
		console.log(totalContentMissingFieldsObj, 'here is the total missing fields')
		this.setState({ mandatoryFieldsData: totalContentMissingFields })
		return totalContentMissingFields.length ? (
			<MandatoryValidations totalContentMissingFields={totalContentMissingFields} />
		) : null
	}

	openRegisterModal = (item) => {
		// console.log('inside open modal')
		this.setState({ company: item, registerCompanyModalVisible: true })
	}
	closeRegisterModal = () => {
		this.setState({ company: '', registerCompanyModalVisible: false })
	}
	registerCompany = (isNewCompany, companyDetails) => {
		let details = companyDetails
		console.log(details, 'here is the details inside registercompanyyy')
		details['isNewCompany'] = isNewCompany
		this.renderContentMandatoryValidations(details)
		this.setState({ isNewCompany: isNewCompany, companyDetails: details })
	}
	renderRegisterCompanyModal = () => {
		const { registerCompanyModalVisible, mandatoryFieldsData } = this.state
		// console.log(this.state.companyDetails, 'here is the====')
		return (
			<Modal show={registerCompanyModalVisible} onHide={() => this.closeRegisterModal()}>
				<Modal.Body>
					<CompanyDetails
						editData={this.state.CompanyDetails}
						createMode={true}
						companyDetails={this.state.companyDetails}
						registerCompany={this.registerCompany}
						mandatoryFieldsData={mandatoryFieldsData}
					// updateInParent={this.updateInParent}
					/>
				</Modal.Body>
				<Modal.Footer>
					<Button onClick={() => this.closeRegisterModal()}>Cancel</Button>
					<Button
						disabled={this.state.DisabledRegisterCompany}
						onClick={() => this.handleRegisterCompany(this.state.companyDetails)}>Register Company</Button>
				</Modal.Footer>
			</Modal>

		)

	}


	renderTable = (heading, contentList) => {
		return (
			<Table>
				<thead>
					<tr>
						{heading.map((head) => (
							<th>{head}</th>
						))}
					</tr>
				</thead>
				<tbody>{contentList && contentList.map((row, index) => this.renderTableRow(row, index))}</tbody>
				{/* {console.log(contentList, 'content listsssssssssssss are')} */}
			</Table>
		)
	}

	renderTableRow = (item, index) => {
		console.log(item, 'itemssssssss')

		const peopleValue = item.peopleValue
		const deletePeoplePermission = this.state.loggedInUserPermissions.includes(
			DefinedPermissions['deleteCompaniesPermission']
		)

		return (
			<tr>
				<td>
					<div>

						{index + 1}

					</div>
				</td>
				<td>

					<div class='row'>
						<div class='col-md-2'
							onClick={() => this.openEditModal(item)}>
							<i class='fas fa-pencil-alt' />

						</div>

						<div
							class='col-md-2'
							onClick={() => {
								this.openDeleteModal(item)
							}}
						>
							<i class='fas fa-trash' />
						</div>

					</div>

				</td>
				<td>
					<div>
						<img style={{ maxWidth: '50%', height: 50 }} src={this.getContentUri(item)} />

					</div>

				</td>
				<td style={{ fontSize: '12px', minWidth: '300px' }}>
					{item.companyName}
				</td>
				<td style={{ fontSize: '12px', minWidth: '300px' }}>
					{item.companyBio}
				</td>

				<td style={{ fontSize: '12px', minWidth: '300px' }}>
					{item.phoneNumber && item.phoneNumber != '' ? (
						<div>
							<text for='text'>PhoneNumber : </text>
							<text>{'+91' + item.phoneNumber}</text>
						</div>)
						: null}
					{item.displayMobileNumberInJobPost && item.displayMobileNumberInJobPost != '' ? (
						<div>
							<text for='text'>DirectlyCall : True</text>
							<text>{item.displayMobileNumberInJobPost}</text>
						</div>)
						: null}
					{item.companyEmail && item.companyEmail != '' ? (
						<div>

							<text for='text'>Email : </text>
							<text>{item.companyEmail}</text>
						</div>)
						: null}
					{item.companyWebsite && item.companyWebsite != '' ? (
						<div>

							<text for='text'>Website : </text>
							<text>{item.companyWebsite}</text>
						</div>)
						: null}
				</td>
				<td style={{ fontSize: '12px', minWidth: '300px' }}>
					{item.companyAddress}
				</td>
				<td style={{ fontSize: '12px', minWidth: '300px' }}>
					{item.SK}
				</td>

			</tr>
		)
	}

	render() {
		const { companyList, headings, mandatoryFieldsData } = this.state
		console.log(mandatoryFieldsData, 'mandatoryFieldsData======')
		return (
			<section className='feed' >

				<div>
					<label>Companies List</label>
				</div>
				<ToastContainer
					position='top-right'
					autoClose={5000}
					hideProgressBar={false}
					newestOnTop={false}
					closeOnClick
					rtl={false}
					pauseOnFocusLoss
					draggable
					pauseOnHover
				/>
				<div className='search Header'>
					<input
						type='text'
						onChange={(e) => {
							this.onChangeSearch(e.target.value)
						}}
						value={this.state.searchQuery}
						placeholder='Search Companies'
					></input>
					<Button
						disabled={this.state.searchQuery ? false : true}
						style={{ marginRight: 10 }}
						onClick={() => {
							this.search()
						}}
					>
						Search
					</Button>
					<Button
						disabled={this.state.searchQuery ? false : true}
						style={{ marginRight: 10 }}
						onClick={() => {
							this.clearSearch()
						}}
					>
						Clear
					</Button>
					{/* <Button >//onClick={this.openRegisterModal()} > */}
					{/* {this.renderContentMandatoryValidations()} */}
					<Button

						style={{
							marginRight: 10,
							right: 0,
							position: 'absolute',
						}}
						onClick={(item) => { this.openRegisterModal(item) }}>
						Register Company
					</Button>

				</div>

				{this.renderRegisterCompanyModal()}
				{this.renderDeleteConfirmationModal()
				}
				{this.renderEditCompaniesModal()}

				{
					this.state.companyList ? (
						<div style={{ marginTop: 10 }}>{this.renderTable(headings, companyList)}</div>
					) : (
						<div>No Companies To Display</div>
					)
				}
				{this.state.nextToken != null &&
					(
						<button onClick={this.loadMore} type='button' className='load-more'>
							Load more
						</button>
					)
				}
			</section >
		)
	}
}

export default ListCompanies